import initmixin from "@/Services/initmixin";

/**
 * Normaliza la respuesta de initmixin.formatrespuesta al formato estándar.
 *
 * initmixin retorna:
 *   - Éxito: response.data (objeto del backend)
 *   - HTTP 422: { error: "<html con mensajes de validación>" }
 *   - HTTP 500: { error: "mensaje del servidor" }
 *   - Error de red: { error: Error object }
 *
 * @param {*} respuesta - Respuesta cruda de initmixin.formatrespuesta
 * @returns {{ success: boolean, data: object|null, message: string }}
 */
export function normalizarRespuesta(respuesta) {
  // Sin respuesta (timeout, status no manejado, etc.)
  if (!respuesta) {
    return {
      success: false,
      data: null,
      message: 'Error de conexión. Verifica tu conexión a internet e intenta nuevamente.'
    };
  }

  // initmixin retorna { error: ... } en caso de fallo
  if (respuesta.error !== undefined) {
    let message = '';

    if (respuesta.error instanceof Error) {
      // Error de red / timeout
      message = 'Error de conexión. Verifica tu conexión a internet e intenta nuevamente.';
    } else if (typeof respuesta.error === 'string' && respuesta.error.length > 0) {
      // HTTP 422 (HTML de validación) o HTTP 500 (mensaje del servidor)
      message = respuesta.error;
    } else {
      message = 'Ocurrió un error en el servidor. Por favor, intenta nuevamente más tarde.';
    }

    return { success: false, data: null, message };
  }

  // El backend ya retorna { success, data, message } — propagarlo directamente
  if (typeof respuesta.success === 'boolean') {
    return {
      success: respuesta.success,
      data: respuesta.data || null,
      message: respuesta.message || ''
    };
  }

  // Respuesta exitosa sin formato estándar (response.data crudo)
  return { success: true, data: respuesta, message: '' };
}

export default {
  // Buscar orden por número para auto facturación
  BUSCAR_ORDEN_PUBLICA: async function(data) {
    let url = '/autofacturacion/buscar-orden';
    const respuesta = await initmixin.formatrespuesta('post', data, url, false);
    return normalizarRespuesta(respuesta);
  },

  // Crear factura desde auto facturación
  CREAR_FACTURA_PUBLICA: async function(data) {
    let url = '/autofacturacion/crear-factura';
    const respuesta = await initmixin.formatrespuesta('post', data, url, false);
    return normalizarRespuesta(respuesta);
  },

  // Obtener datos fiscales del cliente para prellenar
  OBTENER_DATOS_FISCALES: async function(data) {
    let url = '/autofacturacion/datos-fiscales';
    const respuesta = await initmixin.formatrespuesta('post', data, url, false);
    return normalizarRespuesta(respuesta);
  },

  // Validar RFC
  VALIDAR_RFC: async function(data) {
    let url = '/autofacturacion/validar-rfc';
    const respuesta = await initmixin.formatrespuesta('post', data, url, false);
    return normalizarRespuesta(respuesta);
  },

  // Generar PDF de la factura
  GENERAR_PDF_FACTURA: async function(data) {
    let url = '/autofacturacion/generar-pdf';
    const respuesta = await initmixin.formatrespuesta('post', data, url, false);
    return normalizarRespuesta(respuesta);
  },

  // Enviar factura por email
  ENVIAR_FACTURA_EMAIL: async function(data) {
    let url = '/autofacturacion/enviar-email';
    const respuesta = await initmixin.formatrespuesta('post', data, url, false);
    return normalizarRespuesta(respuesta);
  }
}
